import type { Transition } from 'motion/react'

/**
 * Tokens de animación compartidos por toda la app. Todo movimiento sale de aquí para que se sienta como un solo
 * sistema: rápido (150–450 ms), con salida suave y sin rebotes que distraigan del trabajo diario.
 * Las clases CSS equivalentes (`ease-smooth`, duraciones de overlays) viven en `styles.css`.
 */

/** Duraciones en segundos. */
export const DURATION = {
  /** Micro-interacciones: íconos, toggles, errores de campo. */
  fast: 0.15,
  /** Entradas de contenido y overlays. */
  base: 0.22,
  /** Entradas de página y tarjetas. */
  slow: 0.32,
  /** Cuentas progresivas y barras. */
  slower: 0.45,
} as const

/** Curva de salida suave (expo-out): arranca rápido y se asienta sin rebote. */
export const EASE_OUT = [0.22, 1, 0.36, 1] as const
/** Para lo que entra y sale en el mismo gesto (colapsar/expandir). */
export const EASE_IN_OUT = [0.65, 0, 0.35, 1] as const

/** Resortes amortiguados para indicadores que se deslizan (layoutId) y reacomodos de listas. */
export const SPRING = {
  /** Pastillas de navegación y pestañas. */
  snappy: { type: 'spring', stiffness: 520, damping: 40, mass: 0.8 },
  /** Reacomodo de filas (composer, listas editables). */
  soft: { type: 'spring', stiffness: 380, damping: 36, mass: 0.9 },
} as const satisfies Record<string, Transition>

export const TRANSITION = {
  enter: { duration: DURATION.slow, ease: EASE_OUT },
  fast: { duration: DURATION.fast, ease: EASE_OUT },
  base: { duration: DURATION.base, ease: EASE_OUT },
  collapse: { duration: DURATION.base, ease: EASE_IN_OUT },
} as const satisfies Record<string, Transition>

/** Retraso entre elementos de una lista en cascada. */
export const STAGGER = 0.04
/** Desplazamiento vertical de las entradas (px): apenas perceptible. */
export const RISE = 6
